import { Attachment } from 'components/uploadDocs';
import { typedAction } from 'store/modules/base';

export const dataAditamento = (payload: string | undefined) => {
  return typedAction('certificadoRecebiveis/DATA_ADITAMENTO', payload);
};
export const dataAditamentoReset = () => {
  return typedAction('certificadoRecebiveis/DATA_ADITAMENTO/RESET');
};

export const uploadDocumentoAditamento = (payload: Attachment[]) => {
  return typedAction('certificadoRecebiveis/UPLOAD_DOCUMENTO_ADITAMENTO', payload);
};
export const uploadDocumentoAditamentoReset = () => {
  return typedAction('certificadoRecebiveis/UPLOAD_DOCUMENTO_ADITAMENTO/RESET');
};

export type AditamentoAction = ReturnType<
  | typeof dataAditamento
  | typeof dataAditamentoReset
  | typeof uploadDocumentoAditamento
  | typeof uploadDocumentoAditamentoReset
>;
